import React from 'react';
import IssueList from '../../components/Issues/IssueList';

const Issues = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <IssueList />
    </div>
  );
};

export default Issues;


